import { render, staticRenderFns } from "./factory-material.vue?vue&type=template&id=992711e8&scoped=true&"
import script from "./factory-material.vue?vue&type=script&lang=js&"
export * from "./factory-material.vue?vue&type=script&lang=js&"
import style0 from "./factory-material.vue?vue&type=style&index=0&id=992711e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "992711e8",
  null
  
)

export default component.exports